import { checkURL } from 'legacy/lut/helpers/validateRules/checkURL'
import { useCountryInfo } from 'legacy/lut/hooks/useCountryInfo'
import { useValidation } from 'legacy/lut/hooks/useValidation'

import {
  countryWithOptionalURL,
  marketWithOptionalURL,
  PartnerHierarchyType,
} from 'clickNgo/entities/partner/configs'
import { checkIsBranchOrOnline } from 'clickNgo/entities/partner/libs/helpers'

interface IUseUrlValidate {
  country: string
  hierarchyType: PartnerHierarchyType
}

export const useUrlValidate = ({ country, hierarchyType }: IUseUrlValidate) => {
  const countryInfo = useCountryInfo(country)
  const market = countryInfo?.market

  const isCountryWithOptionalUrl = !country || countryWithOptionalURL.includes(country)
  const isMarketWithOptionalUrl = !market || marketWithOptionalURL.includes(market)
  const isBranch = checkIsBranchOrOnline(hierarchyType)
  const isPassed = isMarketWithOptionalUrl || isCountryWithOptionalUrl || isBranch

  const isUrlRequired = !isMarketWithOptionalUrl && !isCountryWithOptionalUrl && !isBranch
  const onUrlValidate = useValidation<string>({ rules: checkURL, isPassed })

  return { onUrlValidate, isUrlRequired }
}
